// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TlqpiMpnUOj_Hhsl2i04 {
    position: fixed;
    bottom: 48px;
    right: 48px;
}

.lzs56CHH1adPWn_qZo20 {
    background-color: white;
    border-radius: 5px;

    width: 45%;
    padding: 18px;

    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
}

.lzs56CHH1adPWn_qZo20 h1 {
    margin: 0;

    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
}

.hRB7apDJ3d9uTN5pIlqG {
    background: #F5F5FA;
    border-radius: 5px;

    width: 100%;
    height: 175px;
    margin-top: 16px;
    margin-bottom: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    transition: .3s;
}

.iMowMnFn2Y9LTBcI9Gwj {
    font-family: Roboto, sans-serif;
    color: #838383;
    margin-top: 4px;
}

.ZvVPvS2FN1s552QXtENe {
    width: 100%;
    height: 48px;

    color: white;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.ZvVPvS2FN1s552QXtENe:hover {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]};
}

.CDCD3V7xnPymC3gVB24Z {
    width: 48px;
    height: 48px;

    display: flex;
    justify-content: center;
    align-items: center;

    border: 1px solid #CFD6FF;
    box-sizing: border-box;
    border-radius: 5px;
}

.UYqCvYQ13MWPBlCvtQWa {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.RxECDT75fU2uSDzwDbzw {
    display: flex;
    flex-direction: row;
}

.HVkN7SdFlU65x30MM41_ {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.HVkN7SdFlU65x30MM41_:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]};
}

.gcNGN3nw0oZtlgBCx3tj {
    border: 1px solid #DADCDE;
    box-sizing: border-box;
    border-radius: 5px;

    width: 100%;
    height: 48px;
    padding: 0 8px;

    margin-bottom: 24px;
    margin-top: 0;
}

.ErD1dkC81Zzwau3kk4tQ {
    margin-bottom: 0;
}

.kjObxIPdJUIfaIqvkc0o {
    background-color: white;
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
    border-radius: 5px;

    width: 350px;
    min-height: 65px;
    padding: 16px;

    display: flex;
    flex-direction: row;
    align-items: center;
}

.kjObxIPdJUIfaIqvkc0o + .kjObxIPdJUIfaIqvkc0o {
    margin-top: 16px;
}

.kjObxIPdJUIfaIqvkc0o .UYqCvYQ13MWPBlCvtQWa {
    font-size:  48px;
    margin-right: 16px;
    width: 10%;
}

.PEbSMjlUg0y6cnH1Ja3D {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.PEbSMjlUg0y6cnH1Ja3D p {
    margin: 0;
    font-size: 16px;
}

.o89d53hPg_Iv626SC7kw {
    width: 90%;
}

.lvz1skSNjHNtjbYBT0Pw {
    width: 100%;
    height: 8px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-gray"]};
    margin-top: 8px;
    border-radius: 5px;
}

.iwAkujTYM3P4huhN2r5H {
    height: 100%;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
    border-radius: 5px;
    transition: 1s;
}

.ZckJTpFTZRRiQvY30vua {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #838383;
}

.mvlqI7MjQVje9HiZ2kmx {
    font-weight: 500;
}

.YEFxwopghoFspvg6Odnf {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
    margin-top: 4px;
    font-size: 14px;
}

.C55l8n9xtP1rvGFbxZ4U {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    padding: 8px;
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-gray"]};
    border-radius: 5px;
    margin-top: 16px;
}

.zFCDP8yATfilK8ejFvow {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.z8dv6_DSYx9QTErLeVFD {
    margin-right: 16px;
    font-size: 36px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.TSdbfjH_90ojIpyI2rJS {
    margin-right: 16px;
}

.gJpD0RcVla1W4qowxNmD {
    color: #838383;
    transition: .3s;
}

.gJpD0RcVla1W4qowxNmD:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.mfSplyNzJlJRNKeF4m9W {
    background-color: #dce1ff;
}

.DAt0ie6Yb3E2lQz33ndy {
    margin: 0;
    font-weight: 500;
}

.lnH7tnkUXB5le0Ux9ABh {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success"]};
    font-size: 48px;
    margin-right: 8px;
}

.DAt0ie6Yb3E2lQz33ndy {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success"]};
}

.NvtodvalPseH3Qf2Sp47{
    opacity:0;
    transition: width 0.5s 0.5s, height 0.5s 0.5s, opacity 0.5s;
}
`, "",{"version":3,"sources":["webpack://./src/components/UploadProgressionBar/UploadProgressionBar.module.css"],"names":[],"mappings":"AAGA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;;IAElB,UAAU;IACV,aAAa;;IAEb,0CAA0C;AAC9C;;AAEA;IACI,SAAS;;IAET,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;;IAElB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;;IAEhB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,YAAY;IACZ,8DAA8B;IAC9B,kBAAkB;;IAElB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,8DAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,mDAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;;IAElB,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,0CAA0C;IAC1C,kBAAkB;;IAElB,YAAY;IACZ,gBAAgB;IAChB,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,WAAW;IACX,8DAAmC;IACnC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,8DAA8B;IAC9B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mDAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,YAAY;IACZ,8DAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mDAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mDAAoB;IACpB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,wDAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,2DAA2D;AAC/D","sourcesContent":["@value colors: \"../library/style/colors.css\";\n@value color-purple, color-purple-dark, color-purple-gray, color-error, color-success from colors;\n\n.container {\n    position: fixed;\n    bottom: 48px;\n    right: 48px;\n}\n\n.upload {\n    background-color: white;\n    border-radius: 5px;\n\n    width: 45%;\n    padding: 18px;\n\n    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);\n}\n\n.upload h1 {\n    margin: 0;\n\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 24px;\n}\n\n.dropzone {\n    background: #F5F5FA;\n    border-radius: 5px;\n\n    width: 100%;\n    height: 175px;\n    margin-top: 16px;\n    margin-bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    transition: .3s;\n}\n\n.label {\n    font-family: Roboto, sans-serif;\n    color: #838383;\n    margin-top: 4px;\n}\n\n.button {\n    width: 100%;\n    height: 48px;\n\n    color: white;\n    background-color: color-purple;\n    border-radius: 5px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.button:hover {\n    background-color: color-purple-dark;\n}\n\n.iconContainer {\n    width: 48px;\n    height: 48px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border: 1px solid #CFD6FF;\n    box-sizing: border-box;\n    border-radius: 5px;\n}\n\n.icon {\n    color: color-purple;\n}\n\n.dropzoneText {\n    display: flex;\n    flex-direction: row;\n}\n\n.dropzoneButton {\n    color: color-purple;\n}\n\n.dropzoneButton:hover {\n    color: color-purple-dark;\n}\n\n.select {\n    border: 1px solid #DADCDE;\n    box-sizing: border-box;\n    border-radius: 5px;\n\n    width: 100%;\n    height: 48px;\n    padding: 0 8px;\n\n    margin-bottom: 24px;\n    margin-top: 0;\n}\n\n.selectLabel {\n    margin-bottom: 0;\n}\n\n.fileUpload {\n    background-color: white;\n    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);\n    border-radius: 5px;\n\n    width: 350px;\n    min-height: 65px;\n    padding: 16px;\n\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.fileUpload + .fileUpload {\n    margin-top: 16px;\n}\n\n.fileUpload .icon {\n    font-size:  48px;\n    margin-right: 16px;\n    width: 10%;\n}\n\n.row {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.row p {\n    margin: 0;\n    font-size: 16px;\n}\n\n.progress {\n    width: 90%;\n}\n\n.barBackground {\n    width: 100%;\n    height: 8px;\n    background-color: color-purple-gray;\n    margin-top: 8px;\n    border-radius: 5px;\n}\n\n.bar {\n    height: 100%;\n    background-color: color-purple;\n    border-radius: 5px;\n    transition: 1s;\n}\n\n.cancel {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 16px;\n    color: #838383;\n}\n\n.bold {\n    font-weight: 500;\n}\n\n.error {\n    color: color-error;\n    margin-top: 4px;\n    font-size: 14px;\n}\n\n.file {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    padding: 8px;\n    background-color: color-purple-gray;\n    border-radius: 5px;\n    margin-top: 16px;\n}\n\n.rowFile {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.fileIcon {\n    margin-right: 16px;\n    font-size: 36px;\n    color: color-purple;\n}\n\n.name {\n    margin-right: 16px;\n}\n\n.clear {\n    color: #838383;\n    transition: .3s;\n}\n\n.clear:hover {\n    color: color-purple;\n}\n\n.hovered {\n    background-color: #dce1ff;\n}\n\n.success {\n    margin: 0;\n    font-weight: 500;\n}\n\n.successIcon {\n    color: color-success;\n    font-size: 48px;\n    margin-right: 8px;\n}\n\n.success {\n    background: color-success;\n}\n\n.fadeOut{\n    opacity:0;\n    transition: width 0.5s 0.5s, height 0.5s 0.5s, opacity 0.5s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-dark"]}`,
	"color-purple-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-gray"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-success": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-success"]}`,
	"container": `TlqpiMpnUOj_Hhsl2i04`,
	"upload": `lzs56CHH1adPWn_qZo20`,
	"dropzone": `hRB7apDJ3d9uTN5pIlqG`,
	"label": `iMowMnFn2Y9LTBcI9Gwj`,
	"button": `ZvVPvS2FN1s552QXtENe`,
	"iconContainer": `CDCD3V7xnPymC3gVB24Z`,
	"icon": `UYqCvYQ13MWPBlCvtQWa`,
	"dropzoneText": `RxECDT75fU2uSDzwDbzw`,
	"dropzoneButton": `HVkN7SdFlU65x30MM41_`,
	"select": `gcNGN3nw0oZtlgBCx3tj`,
	"selectLabel": `ErD1dkC81Zzwau3kk4tQ`,
	"fileUpload": `kjObxIPdJUIfaIqvkc0o`,
	"row": `PEbSMjlUg0y6cnH1Ja3D`,
	"progress": `o89d53hPg_Iv626SC7kw`,
	"barBackground": `lvz1skSNjHNtjbYBT0Pw`,
	"bar": `iwAkujTYM3P4huhN2r5H`,
	"cancel": `ZckJTpFTZRRiQvY30vua`,
	"bold": `mvlqI7MjQVje9HiZ2kmx`,
	"error": `YEFxwopghoFspvg6Odnf`,
	"file": `C55l8n9xtP1rvGFbxZ4U`,
	"rowFile": `zFCDP8yATfilK8ejFvow`,
	"fileIcon": `z8dv6_DSYx9QTErLeVFD`,
	"name": `TSdbfjH_90ojIpyI2rJS`,
	"clear": `gJpD0RcVla1W4qowxNmD`,
	"hovered": `mfSplyNzJlJRNKeF4m9W`,
	"success": `DAt0ie6Yb3E2lQz33ndy`,
	"successIcon": `lnH7tnkUXB5le0Ux9ABh`,
	"fadeOut": `NvtodvalPseH3Qf2Sp47`
};
export default ___CSS_LOADER_EXPORT___;
